import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Check, IsOpen, Times, Trash } from '../../../components/Icon';
import { ButtonBar } from '../../../components/ButtonBar';
import { Loader } from '../../../components/Loader';
import { FormField } from '../../../components/FormFields';
import { HBox } from '../../../components/Box';
import { selectUserId, selectWorks, selectPermissions } from '../../Api/selectors';
import { deleteVehicleProperty, setVehicleProperties, setVehicleProperty } from '../actions';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { selectUser } from '../../Users/selectors';
import { fetchUser } from '../../Users/actions';
import { getPropByName, getPropertyValueObjectByName } from '../../../utils/props';
import { getDate } from '../helpers';
import _ from 'lodash';
import cn from 'classnames';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import styles from './CardClaim.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { VBox } from '../../../components/Box';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { hasPermissions } from '../../../utils/helpers/permissions';



const Container = styled.div`
  .button.inactive-red {
    background-color: #fdbecb;
  }

  .button.inactive {
    background-color: white;
    color: black;
    border: 1px solid black;
}

  .button.inactive-green {
    background-color: #a5ebd6;
  }

  .button:hover {
    background-color: #1c9789!important;
    color: white;
  }

  .button.green {
    background-color: #00BFAE;
  }

  .button.warning {
    color: #fff;
    background-color: #fa5c7c;
  }

  .initials-wrapper {
    width: 40px;
    height: 40px;
    background-color: rgba(29, 155, 209, 0.1);
    justify-content: center;
    border-radius: 50%;
  }
`;

const STATE = {
  isOpen: false,
  claim_remark: '',
  isOpen: false,
};

class VehicleClaimCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.vehicle?.user_changed_claim) {
      this.props.fetch(this.props.vehicle?.user_changed_claim, result => this.setState({ user: result }));
    }
    if (hasPermissions(this.props.permissions, DEP_WORKSHOP )) {
      this.setState({ isOpen: true });
    }
    if (this.props.vehicle?.claim_remark?.trim()?.length) {
      this.setState({ claim_remark: this.props.vehicle?.claim_remark });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.vehicle?.user_changed_claim && this.props.vehicle?.user_changed_claim != this.state?.user?.id) {
      this.props.fetch(this.props.vehicle?.user_changed_claim, result => this.setState({ user: result }));
    }
  }

  get userChangedClaim() {
    let name = this.state.user ? getPropByName(this.state.user, 'name') : this.props.changedClaimUser?.name || '';

    let surname = this.state.user ? getPropByName(this.state.user, 'surname') : this.props.changedClaimUser?.surname || '';
    return `${name} ${surname}`;
  }

  get renderInitials() {
    let name = this.state.user ? getPropByName(this.state.user, 'name') : this.props.changedClaimUser?.name || '';

    let surname = this.state.user ? getPropByName(this.state.user, 'surname') : this.props.changedClaimUser?.surname || '';
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  get claimUpdatedAt() {
    const date = getPropertyValueObjectByName(this.props.vehicle, 'active_claim')?.updatedAt;
    const parsedDate = getDate(date, true);
    return parsedDate;
  }

  render() {
    const vehicle = this.props.vehicle;
    if (this.props.works) return <LoadingDetailsPageCard />;
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
        <HBox vCenter left>
          <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.claim.title')}</h2>
          <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
        </HBox>
              {this.state.isOpen && (   <>
          <div className="mb-2 mt-2" style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>

            <Button
              style={{ width: '100%' }}
              onClick={() => this.props.setValues('1', this.props.loggedInUserId, this.state.claim_remark)}
              small
              className={cn(vehicle.active_claim != '1' ? 'inactive' : 'warning', styles.button)}
            >
              {vehicle.active_claim == '1'
                ? this.lbl('vehicle.info.claim.claim_actief')
                : this.lbl('vehicle.info.claim.claim_aanmaken')}
            </Button>
            <Button
              style={{ width: '100%' }}
              onClick={() => this.props.setValues('2', this.props.loggedInUserId, this.state.claim_remark)}
              small
              className={cn(vehicle.active_claim != '2' ? 'inactive' : 'warning', styles.button)}
            >
              {vehicle.active_claim == '1'
                ? this.lbl('vehicle.info.claim.wacht_op_beoordelen')
                : this.lbl('vehicle.info.claim.claim_ter_beoordeling')}
            </Button>
            <Button
              style={{ width: '100%' }}
              onClick={() => this.props.setValues('0', this.props.loggedInUserId, this.state.claim_remark, res => {})}
              small
              className={cn(vehicle.active_claim == '1' || vehicle.active_claim == '2' ? 'inactive' : 'green', styles.button)}
            >
              {vehicle.active_claim != '1'
                ? this.lbl('vehicle.info.claim.geen_claim')
                : this.lbl('vehicle.info.claim.de-claim')}
            </Button>

          </div>

          <div className={styles.remarkCard}>
            <HBox className="gap-2" vCenter right>
              <ButtonComponent
                style={'ButtonSoftEdit'}
                size={'btn-sm'}
                onClick={() => this.props.setInfo(this.state.claim_remark)}
              >
                <Check className={styles.check} />
              </ButtonComponent>
              <ButtonComponent
                style={'ButtonSoftDelete'}
                size={'btn-sm'}
                onClick={() => this.setState({ claim_remark: this.props.vehicle?.claim_remark })}
              >
                <Trash />
              </ButtonComponent>
            </HBox>

            <VBox className="remark" vCenter>
              <div className={styles.nameRemark}>{this.renderInitials}</div>
            </VBox>
            <VBox className="remark mb-2" vCenter>
              <FormField label={this.lbl('vehicle.details.status_log.remark')}>
                <textarea
                  style={{
                    resize: 'none',
                    height: '70px',
                    width: '100%',
                    padding: '8px',
                    borderRadius: '0.375rem',
                    fontWeight: '500',
                  }}
                  value={this.state.claim_remark}
                  onChange={e => this.setState({ claim_remark: e.target.value })}
                />
              </FormField>
            </VBox>

            <HBox right>{this.claimUpdatedAt || ''}</HBox>
          </div>
             </> )}
        </Container>
      </Card>
    );
  }
}

VehicleClaimCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    works: selectWorks([`${REQUEST_VEHICLE_PROPERTY_UPDATE}-active_claim`, REQUEST_VEHICLE]),
    loggedInUserId: selectUserId(),
    changedClaimUser: selectUser(ownProps.vehicle?.user_changed_claim),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(id, callback) {
      dispatch(fetchUser(id, callback));
    },
    unsetValue() {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'active_claim'));
    },
    setValue(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'active_claim', val));
    },
    setInfo(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'claim_remark', val));
    },
    setValues(claim, user, info = '', callback) {
      let props = info
        ? ['user_changed_claim', user, 'active_claim', claim, 'claim_remark', info]
        : ['user_changed_claim', user, 'active_claim', claim, 'claim_remark', ' '];
      dispatch(
        setVehicleProperties(
          ownProps.vehicle.id,
          _.chunk(props, 2).map(pair => ({
            propertyName: pair[0],
            propertyValue: pair[1],
          })),
          callback,
        ),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleClaimCard = compose(withConnect, withRouter)(VehicleClaimCardComp);
